import { render } from "./BlackBack.svg?vue&type=template&id=4cecfaac"
const script = {}
script.render = render

export default script